



















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters({
      brandContrast: "brand/contrast"
    })
  }
})
export default class PoweredByUpmind extends Vue {
  @Prop({ required: false, default: true })
  public hasIcon!: boolean;
  @Prop({ required: false, default: null })
  public contrast!: string | null;
  public brandContrast!: string;
  public domain: string = process.env.VUE_APP_UPMIND_STOREFRONT as string;

  public get contrastColor() {
    return this.contrast || this.brandContrast;
  }

  public get logomarkUrl() {
    return `/assets/images/interface/logos/upmind—logomark—${this.contrastColor}-on-transparent.svg`;
  }
}
